import { ToolIde } from "../components/custom-tools/tool-ide/ToolIde";

function ToolIdePage() {
  return <ToolIde />;
}

export { ToolIdePage };
